import Vue from 'vue'
import store from './vuex/store'
import VueI18n from 'vue-i18n'
import filters from './utils/filters'

import './assets/styles/custom.scss'
import 'element-ui/lib/theme-chalk/display.css'
import locales from './locales/locales.json'

import { Loading } from 'element-ui'
import deLocale from 'element-ui/lib/locale/lang/de'
import enLocale from 'element-ui/lib/locale/lang/en'
import ElementLocale from 'element-ui/lib/locale'
import { scrollTo } from './utils/utils'
import App from './App'

import 'core-js/stable'

var messages = {
  en: {
    dateFormat: 'MM/dd/yyyy',
    firstDayOfWeek: '7',
    deck: locales.en,
    ...enLocale
  },
  de: {
    dateFormat: 'dd.MM.yyyy',
    firstDayOfWeek: '1',
    deck: locales.de,
    ...deLocale
  }
}

Vue.config.debug = !!(window.initData.debugMode & (1 << 2))
Vue.config.devtools = !!(window.initData.debugMode & (1 << 3))

filters.create()

Vue.use(VueI18n)

Vue.config.lang = window.initData.language
Vue.config.fallbackLang = 'de'

export const i18n = new VueI18n({
  locale: window.initData.language.toLowerCase(),
  messages,
  silentTranslationWarn: !(window.initData.debugMode & (1 << 4))
})

ElementLocale.i18n(key => i18n.t(key))

Vue.use(Loading.directive)

Vue.directive('draggabilly', {
  bind: function (elem, binding, vnode, oldVnode) {
    var options = binding.value || {}
    var draggie = new Draggabilly(elem, options)
    var directives = vnode.data.directives
    for (var i in directives) {
      var dir = directives[i]
      if (dir.name === 'draggabilly-on') {
        draggie.on(dir.arg, dir.value)
      } else if (dir.name === 'draggabilly-once') {
        draggie.on(dir.arg, dir.value)
      }
    }
  }
})

Vue.prototype.$scrollTo = scrollTo

/* eslint-disable no-new */
new Vue({
  el: '#scheduleApp',
  store,
  i18n,
  filters,
  render: h => h(App)
})
